import { FC } from "react";
import { Box, Flex, Icon } from "@smile2impress/components/relaunch";
import {
    Picture,
    EsIcon,
    FrIcon,
    ItIcon,
    UsIcon,
    UaIcon,
    GbIcon,
    PtIcon,
    DeIcon,
    NlIcon,
    SeIcon,
    DkIcon,
    WavesPatternIcon,
} from "@smile2impress/components";
import { UTSLocale } from "@smile2impress/attraction-constants";
import { UniversalTextElement } from "templates/relaunch/primitives/UniversalTextElement";

import { DoctorsProfileProps } from "./DoctorsProfile.types";

export const DoctorsProfile: FC<DoctorsProfileProps> = ({
    title,
    text,
    image,
    iconLocale,
    withWavePattern = false,
}) => {
    const iconComponent = ((locale) => {
        switch (locale) {
            case UTSLocale.SPAIN_ES:
                return EsIcon;
            case UTSLocale.PORTUGAL_PT:
                return PtIcon;
            case UTSLocale.FRANCE_FR:
                return FrIcon;
            case UTSLocale.ITALY_IT:
                return ItIcon;
            case UTSLocale.GB_EN:
                return GbIcon;
            case UTSLocale.US_EN:
                return UsIcon;
            case UTSLocale.UKRAINE_UK:
                return UaIcon;
            case UTSLocale.GERMANY_DE:
                return DeIcon;
            case UTSLocale.NL_NL:
                return NlIcon;
            case UTSLocale.SWEDEN_SE:
                return SeIcon;
            case UTSLocale.DENMARK_DK:
                return DkIcon;
            default:
                return null;
        }
    })(iconLocale);

    return (
        <Flex
            direction="column"
            justifyContent="flex-start"
            rowGap={2}
            bgColor="base.grey"
            p={[2, 2, 3]}
            borderRadius="sm"
            position="relative"
            overflow="hidden"
            height="100%"
        >
            {withWavePattern && (
                <Box
                    position="absolute"
                    zIndex="0"
                    top={["-65px", "-65px", "0px"]}
                    left={["-140px", "-140px", "-100px"]}
                >
                    <WavesPatternIcon
                        width="598px"
                        height="640px"
                        gradientColors={["#fff"]}
                    />
                </Box>
            )}
            <Flex
                direction={"row"}
                justifyContent="space-between"
                position="relative"
                zIndex={1}
            >
                <Flex borderRadius="sm" overflow="hidden">
                    <Picture width="132px" height="132px" {...image} />
                </Flex>
                <Flex>
                    {iconComponent && (
                        <Icon
                            w="28px"
                            h="28px"
                            as={iconComponent}
                            mb={[0, 0, 2]}
                        />
                    )}
                </Flex>
            </Flex>
            <Flex position="relative" zIndex={1} p={0}>
                <UniversalTextElement
                    title={title}
                    text={text}
                    extraTitleStyles={{ textStyle: ["H3"], as: "h4" }}
                />
            </Flex>
        </Flex>
    );
};
